<template>
    <li class="nav-item">
        <a class="nav-link" :href="route" :class="{'active': isActive || active}">
            <slot></slot>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        route: { default: null },
        active: { default: false },
    },

    data() {
        return {
            isActive: false,
        }
    },

    created() {
        window.addEventListener('hashchange', () => {
            this.checkActiveState();
            this.emitEvents();
        })

        this.checkActiveState();
        this.emitEvents();
    },

    methods: {
        checkActiveState() {
            this.isActive = this.route === window.location.hash;
        },

        emitEvents() {
            this.$emit('change', this.route.substring(2));
        }
    },
}
</script>
